import React, { useState, useEffect, useContext } from "react";
import { css } from "emotion";
import { Button, Grid, Header, Message, Modal } from "semantic-ui-react";
import { getRequest, postRequest } from "../../../helpers/ApiHelpers";
import { withRouter } from "react-router-dom";
import { UserContext } from "../../User";
import { StateContext } from "../../State";
import Card from "semantic-ui-react/dist/commonjs/views/Card";
import { convertToFileDownload } from "../../../helpers/ConvertToFileDownload";
import { Highlight } from "../../search/Highlight";

const paragraphStyles = css({
  color: "#000",
  fontSize: 14,
  lineHeight: 1.5,
  whiteSpace: "pre-wrap"
});
const labelStyles = css({
  fontFamily: "Fakt-Bold",
  fontSize: 14,
  color: "#707898",
  marginBottom: 14,
  marginTop: 24
});

function Recordings({ history, match: { params }, recordingSearchResults }) {
  const { user } = useContext(UserContext);
  const { selectedState } = useContext(StateContext);

  const [state, setState] = useState({
    recordings: [],
    noResults: false,
    initialLoaded: false,
    recordingToDelete: null
  });

  async function getRecordingsByState() {
    const result = await getRequest("/recording/getRecordingsByState", {
      stateId: selectedState
    });
    if (result.success) {
      setState(state => ({
        ...state,
        recordings: result.data,
        initialLoaded: true
      }));
    }
  }

  async function deleteRecording(id) {
    const result = await postRequest(`/recording/deleteRecording?id=${id}`, id);
    if (result.success) {
      setState(state => ({
        ...state,
        recordings: state.recordings.filter(r => r.id !== id),
        recordingToDelete: null
      }));
    }
  }

  async function download(id) {
    const result = await getRequest(
      `/recording/downloadRecordingFile?id=${id}`
    );
    if (result.success) {
      convertToFileDownload(result.data.base64File, result.data.name);
    }
  }

  useEffect(() => {
    if (selectedState) {
      getRecordingsByState();
    }
  }, [selectedState]);

  const filteredRecordings = recordingSearchResults
    ? recordingSearchResults
    : state.recordings;

  return (
    <React.Fragment>
      {!recordingSearchResults && (
        <Grid>
          <Grid.Row columns={2} verticalAlign="middle">
            {(user.isOwner || user.isOwnerPlus) && (
              <Grid.Column
                floated="right"
                className={css({ textAlign: "right" })}
              >
                <Button
                  icon
                  className="blueButton"
                  onClick={() => history.push(`/info/new-recording`)}
                >
                  <i className="fal fa-plus" />
                </Button>
                <span
                  className={css({
                    fontFamily: "Fakt-Bold",
                    fontSize: 14,
                    color: "#000",
                    cursor: "pointer",
                    "&:hover": {
                      color: "#00b8d4"
                    }
                  })}
                  onClick={() => history.push(`/info/new-recording`)}
                >
                  New Recording
                </span>
              </Grid.Column>
            )}
          </Grid.Row>
        </Grid>
      )}
      <div
        className={css({
          marginBottom: recordingSearchResults ? 0 : 19.75,
          marginTop: recordingSearchResults ? 0 : 40
        })}
      >
        {filteredRecordings &&
          filteredRecordings.map(r => (
            <Card fluid style={{ padding: 28 }} key={r.id}>
              <Card.Content>
                {(user.isOwner || user.isOwnerPlus) && (
                  <React.Fragment>
                    <i
                      onClick={() =>
                        setState(state => ({ ...state, recordingToDelete: r }))
                      }
                      className="fal fa-trash"
                      style={{
                        position: "absolute",
                        right: 56,
                        cursor: "pointer"
                      }}
                    />
                    <i
                      onClick={() =>
                        history.push(`/info/edit-recording/${r.id}`)
                      }
                      className="fal fa-pencil"
                      style={{
                        position: "absolute",
                        right: 28,
                        cursor: "pointer"
                      }}
                    />
                  </React.Fragment>
                )}
                <Card.Header content={<Highlight children={r.subject} />} />
                <Card.Description
                  style={{ whiteSpace: "pre-wrap" }}
                  content={<Highlight children={r.note} />}
                />
                {r.recordingFiles && r.recordingFiles.length > 0 && (
                  <div className={labelStyles}>Attachments</div>
                )}
                {r.recordingFiles &&
                  r.recordingFiles.map(f => (
                    <p className={paragraphStyles} key={f.id}>
                      <a
                        onClick={() => download(f.id)}
                        className={css({
                          "&:hover": {
                            textDecoration: "underline",
                            color: "#00b8d4"
                          }
                        })}
                      >
                        <i
                          className="fal fa-paperclip"
                          style={{ color: "#00b8d4", marginRight: 8 }}
                        />
                        <Highlight children={f.fileName} />
                      </a>
                    </p>
                  ))}
              </Card.Content>
            </Card>
          ))}
        {state.recordings.length < 1 && state.initialLoaded && (
          <Message size="big">No available recordings...</Message>
        )}
      </div>
      {state.recordingToDelete && (
        <Modal
          size={"tiny"}
          open={state.recordingToDelete !== null}
          onClose={() =>
            setState(state => ({ ...state, recordingToDelete: null }))
          }
          dimmer="inverted"
        >
          <Modal.Header>Delete Recording</Modal.Header>
          <Modal.Content>
            <p>Are you sure you want to delete?</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              negative
              onClick={() =>
                setState(state => ({ ...state, recordingToDelete: null }))
              }
              style={{
                backgroundColor: "#fff",
                border: "solid 1px #e5e5ea",
                color: "rgba(0, 0, 0, 0.87)"
              }}
            >
              No
            </Button>
            <Button
              positive
              onClick={() => deleteRecording(state.recordingToDelete.id)}
              style={{ backgroundColor: "#1f2b5e" }}
            >
              Yes
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </React.Fragment>
  );
}

export default withRouter(Recordings);
